// #239: 유의사항 줄 파서 — 어드민 입력 서식(불릿 on/off · Enter 줄바꿈 · 들여쓰기)을 그대로 보존.
//   기본은 '맨 텍스트'(자동 불릿 없음). 클라가 원하는 줄에만 '- '/'* '/'• ' 마커를 붙여 불릿 표시.
//   - '- '→불릿 / 일반 텍스트→문장(불릿 없음) / 앞 공백 2칸=들여쓰기 1단계 / 빈 줄→문단 간격.
//   기존 투어는 일회성 마이그레이션으로 각 줄 앞에 '- ' 를 주입해 현행(불릿) 모양을 유지함(무회귀).
//
//   서비스 렌더(TourDetail)와 어드민 미리보기(TourServiceDetail)가 동일하게 보이도록 단일 출처로 공유.
export function parseNoticeLines(items) {
  const list = Array.isArray(items) ? items : [];
  return list.map((item) => {
    if (typeof item !== 'string') return { kind: 'bullet', item, indent: 0 };
    const expanded = item.replace(/\t/g, '  ');
    const lead = (expanded.match(/^ */) || [''])[0].length;
    const indent = Math.min(3, Math.floor(lead / 2));
    const rest = expanded.slice(lead);
    if (rest.trim() === '') return { kind: 'space', indent: 0 };
    const m = rest.match(/^[-*•]\s+(.*)$/);
    if (m) return { kind: 'bullet', item: m[1], indent };
    return { kind: 'text', item: rest, indent };
  });
}
